import BlogGrid from "../components/grid/BlogGrid";
import Sidebar from "../components/sidebar/Sidebar";

export default function Home() {
    return (
        <section className="wrapper">
            <Sidebar />
            <BlogGrid />
        </section>
    );
}
